<template>
    <div class="section-aditional-infos">
        <div class="row g-0">

            <div class="col-12 col-lg-6 col-xxl-5">
               <div class="section-text">
                   <div class="section-spacing"></div>
                    <div class="section-text-content">
                        <h4 v-if="sectionBlock.sectionTitle !== ''" class="mb-5">{{sectionBlock.sectionTitle}}</h4>
                        <div v-if="sectionBlock.sectionText !== ''" v-html="sectionBlock.sectionText"></div>
                        <a v-if="sectionBlock.sectionLink !== null" :href="sectionBlock.sectionLink.fr" class="button mt-4">
                            {{sectionBlock.sectionLinkText}}
                        </a>
                    </div>
               </div>
            </div>

            <div class="col-12 col-lg-6 col-xxl-7">
               <div
                    v-if="sectionBlock.img !== null"
                    class="section-image bg-img"
                    :style="{ backgroundImage: `url(${sectionBlock.img.url})` }"
                >
               </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'sectionAditionalInfos',
    components: {
        // AssetLoader
    },
    props: {
        sectionBlock: {
            type: Object,
            required: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
        shuffleArray(array) {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1))
                ;[array[i], array[j]] = [array[j], array[i]]
            }
            return array.slice(0, 3)
        },
    },
    // On loaded...
    mounted() {},
}
</script>
